<script>
import { fabric } from 'fabric';
import ImageBoxTool from './ImageBoxTool';

export default {
  name: 'AddCircleImageBoxTool',
  extends: ImageBoxTool,
  data() {
    return {
      icon: 'circle',
    };
  },
  methods: {
    action() {
      this.addCircle();
    },
    addCircle() {
      const circle = new fabric.Circle({
        radius: 30,
        fill: this.parent.fillColor,
        strokeWidth: 5,
        stroke: this.parent.strokeColor,
        top: 100,
        left: 100,
      });
      this.canvas.add(circle).setActiveObject(circle);
    },
  },
};
</script>
